import styled from 'styled-components';
import { useState } from 'react';
import { Text } from '@adobe/react-spectrum';
import { DialogTrigger } from 'components/basic/dialogTrigger';
import { Annotation } from 'constants/constants';
import { AnnotationVariant } from './common/annotation';

const DialogBodyLayout = styled.div`
  display: grid;
`;

interface UpdateExecuteKeyButtonProps {
  updateExecuteKey: () => Promise<Annotation | undefined>;
  setAnnotationVariant: React.Dispatch<React.SetStateAction<AnnotationVariant>>;
  setAnnotationMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const UpdateExecuteKeyButton = (props: UpdateExecuteKeyButtonProps) => {
  const { updateExecuteKey, setAnnotationVariant, setAnnotationMessage } =
    props;
  const [isOpen, setIsOpen] = useState(false);

  const updateSettingsExecuteKey = async () => {
    const updateResult = await updateExecuteKey();
    setAnnotationVariant(updateResult ? updateResult.VARIANT : '');
    setAnnotationMessage(updateResult ? updateResult.MESSAGE : '');
    setIsOpen(!isOpen);
  };

  const handleOnOpenChange = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <DialogTrigger
        isOpen={isOpen}
        onOpenChange={handleOnOpenChange}
        buttonContent={'keyの再発行'}
        margin={0}
        dialogSize={'L'}
        title={'最終確認'}
        mainButtonProps={{
          onClick: updateSettingsExecuteKey,
          label: 'OK',
        }}
        subButtonProps={{
          onClick: handleOnOpenChange,
          label: 'キャンセル',
        }}
        minWidth={115}
      >
        <DialogBodyLayout>
          <Text>execute-Keyを再発行すると</Text>
          <Text>RICOH Chatbot Service側の再設定が必要になります</Text>
          <Text>再発行を行いますか</Text>
        </DialogBodyLayout>
      </DialogTrigger>
    </div>
  );
};
